import { BuildResume } from './BuildResume'

export default BuildResume
